import TitleAnalysis from './TitleAnalysis';
import TitleAnalysisNs from '../types/TitleAnalysis';
import ReadabilityAndLengthAnalysis from './ReadabilityAndLengthAnalysis';
import ReadabilityNs from '../types/ReadabilityAndLengthAnalysis';
import JobAd from './JobAd';
import JobAdNs from '../types/JobAd';
import Recruitomat from './Recruitomat';
import RecruitomatNs from '../types/Recruitomat';
import Requirements from '@/store/modules/Requirements';
import RequirementsNs from '../types/Requirements';

export default function (config) {
    return {
        namespaced: true,
        state: () => ({
            title: '',
            text: '',
        }),
        mutations: {
            setTitle(state, title) {
                state.title = title;
            },
            setText(state, text) {
                state.text = text;
            },
        },
        actions: {
            async loadAnalysis({ state, dispatch }) {
                dispatch(TitleAnalysisNs.actions.LOAD_SCORE, {
                    title: state.title,
                });
                dispatch(
                    ReadabilityNs.actions
                        .LOAD_READABILITY_FREETEXT_AND_LENGTH_ANALYSIS,
                    { text: state.text },
                );
                dispatch(JobAdNs.actions.LOAD_CUSTOM_JOB_AD, {
                    title: state.title,
                    fulltext: state.text,
                });
                dispatch(RecruitomatNs.actions.LOAD_CUSTOM_PREDICTIONS, {
                    title: state.title,
                    fulltext: state.text,
                });
                dispatch(RequirementsNs.actions.LOAD_REQUIREMENTS_FREETEXT, {
                    text: state.title + ' ' + state.text,
                });
            },
        },
        modules: {
            TitleAnalysis: TitleAnalysis(
                config.titleAnalysis,
                config.titleTune,
            ),
            ReadabilityAndLengthAnalysis: ReadabilityAndLengthAnalysis(
                config.readability,
            ),
            JobAd: JobAd(config),
            Recruitomat: Recruitomat(config.recruitomat),
            Requirements: Requirements(config.requirements),
        },
    };
}
